import { MagicConfigMixin, ContentMixin, RoutablePage } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let StaticPageComponent = class extends Mixins(MagicConfigMixin, ContentMixin) {
  onError() {
    this.routeTo({ route: RoutablePage.NOT_FOUND });
  }
};
__decorateClass([
  Prop(String)
], StaticPageComponent.prototype, "slug", 2);
__decorateClass([
  Prop(Boolean)
], StaticPageComponent.prototype, "hideTitle", 2);
__decorateClass([
  Prop(Boolean)
], StaticPageComponent.prototype, "hideImage", 2);
__decorateClass([
  Prop(Boolean)
], StaticPageComponent.prototype, "hideDescription", 2);
__decorateClass([
  Prop(String)
], StaticPageComponent.prototype, "variant", 2);
StaticPageComponent = __decorateClass([
  Component({
    name: "static-page"
  })
], StaticPageComponent);

export default StaticPageComponent;
